<template lang="pug">
.rank-item(@click="$emit('click')")
  .rank(:class="{'top': (index + 1) <= 3}") {{ index + 1 }}
  .title {{ itemData.title }}
  .extend {{ itemData.extend }}
</template>

<script>
export default {
  name: "PolicyRankItem",
  props: {
    index: Number,
    itemData: Object,
  }
}
</script>

<style lang="scss" scoped>
.rank-item{
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  .rank{
    @include square(18px);
    background: #EEEEEE;
    color: #555555;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    &.top{
      background: rgba(255, 92, 0, 0.61);
      color: #FFFFFF;
    }
  }
  .title{
    flex: 1;
    padding-left: 8px;
    font-size: 16px;
    color: #202948;
    @include textOverflow();
  }
  .extend{
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
    white-space: nowrap;
  }
}
</style>
